var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',{staticClass:"align-left"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):(_vm.rowData)?_c('div',[_c('span',{class:_vm.getCssClasses(_vm.rowData.request, true),attrs:{"data-tooltip":_vm.getTitle(_vm.rowData.request)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }